import { createSelector } from 'reselect';
import { getLanguage, getStateSlice } from './selectors';

function translate(language, shelfLifeTimeUnits) {
  const translations = shelfLifeTimeUnits.get('info').get(language);
  const code = shelfLifeTimeUnits.get('code');
  if (!translations) {
    throw new Error(
      `No translations available for temperatures unit of measure '${code}' with language '${language}'`
    );
  }
  return {
    code,
    name: translations.get('text'),
    shortName: translations.get('textShort'),
    slug: translations.get('slug')
  };
}

const getShelfLifeTimeUnitsMap = state =>
  getStateSlice(state).get('shelfLifeTimeUnits');

export const getShelfLifeTimeUnitsUnits = createSelector(
  getShelfLifeTimeUnitsMap,
  shelfLifeTimeUnitsMap => shelfLifeTimeUnitsMap.toList()
);

export const getShelfLifeTimeUnitsTranslated = code =>
  createSelector(
    getLanguage,
    getShelfLifeTimeUnitsMap,
    (language, shelfLifeTimeUnitsMap) => {
      if (!code) {
        return null;
      }
      const shelfLifeTimeUnits = shelfLifeTimeUnitsMap.get(code);
      return translate(language, shelfLifeTimeUnits);
    }
  );
